export default "__VITE_ASSET__C8OdKLT2__"